import { observable, computed, reaction } from "mobx";
import _ from 'lodash';
import { getByAtribute } from "../../../../utils/formatar";
import moment from "moment";
import FluxoStore from "../../comum/stores/FluxoStore";

export default class FluxoMigracaoStore extends FluxoStore {

    @observable momentData;
    @observable data;
    @observable dataValidacao;
    @observable observacoesMigracao;
    @observable dados;
    @observable loading;
    @observable produtosFiltrados;
    @observable itemSelecionado;
    @observable produtoId;
    @observable produtosMigracao;
    @observable atributosPlanejamento;
    @observable alertaPlanejamento;
    @observable centroCustoDebitoSelecionado;
    @observable parametrosGeraisStore;
    @observable targetCentroCustoDebito;

    @observable isLoadingGestorArDebito;
    @observable isLoadingArDebito;
    @observable gestoresArDebito;
    @observable gestorARError;
    @observable justificativaInicial;
    @observable justificativaAlterada;
    @observable produtoSelecionado;
    @observable isLoadingProduto;
    @observable dadosOriginais;


    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);
        this.parametrosGeraisStore = parametrosGeraisStore;

        this.filtrarProdutos = _.debounce(this._filtrarProdutosPorTermo, 1000);

        this.isSolicitacaoProrrogacao = false;
        this.isLoadingGestorArDebito = false;
        this.isLoadingArDebito = false;
        this.isLoadingProduto = false;
        this.gestoresArDebito = [];
        this.gestorARError = [];
        this.justificativaAlterada = false;
        this.produtos = [];
        this.produtoSelecionado = undefined;

        this.produtosMigracao = [];
        this.gestoresArDebito = [];
        this.targetCentroCustoDebito = null;
        this.dadosOriginais = {
            centroCustoDebito: null,
            matriculaGestorDebito: null,
            justificativaContratacaoId: null,
            produtoId: null
        }

        reaction(
            () => this.solicitacao.gestorAreaDebito,
            gestorAr => {
                if (!gestorAr) {
                    this.gestorARError = [];
                }
            }
        );

/*         reaction(
            () => this.solicitacao.produtoId,
            idProduto => {
                if (idProduto && idProduto != "") {
                    produto = {
                        id: this.solicitacao.produtoId,
                        label: `${this.solicitacao.produto.nome} (${this.solicitacao.produto.codigo})`
                    }
                    this.produtoSelecionado = produto;
                }
            }
        );  */

    }

    @computed
    get sistemaAlocacaoVigente() {
        return this.alocacoesProdutoMot
            .filter(a => a.status === 'Vigente')
            .map(a => a.sistemaAlocacao)[0];
    }

    @computed
    get datasDisponiveis() {
        if (this.alocacoesProdutoMot.length > 0 && this.alocacoesProdutoMot[0]) {

            let datas = {
                dataInicio: null,
                dataFim: null,
                datasRestritas: []
            }
            let dataInicio, diferenca;

            const dataAtual = moment();
            const diaAtual = dataAtual.date();

            // recupera o dia de geração do timesheet
            const diaGerControlePonto = this.parametrosGeraisStore.parametros.pgmDiaGerControlePonto;

            if (diaAtual >= diaGerControlePonto) {
                // se o dia atual for maior ou igual que o dia do timesheet
                // define a data inicio como o dia do timesheet no mês atual 
                diferenca = diaAtual - diaGerControlePonto;
                dataInicio = dataAtual.subtract(diferenca, 'days');
            } else if (diaAtual < diaGerControlePonto) {
                // se o dia atual for menor que o dia do timesheet
                // //define a data inicio como o dia do timesheet no mês anterior
                diferenca = diaGerControlePonto - diaAtual;
                dataInicio = dataAtual.add(diferenca, 'days').subtract(1, 'months');
            }

            // Verifica se houve troca de sistema de alocação ou migrou para justificativa exclusiva p/ custeio direto   
            const isSistemaAlocacaoDiferente = this.isSistemaAlocacaoDiferente || this.sistemaAlocacaoVigente == 'MEDIAPULSE'; //this.isCentroCustoDebitoMediaPulse;

            datas = isSistemaAlocacaoDiferente ? this.montaDataInicioAlocacaoDiferente(moment(dataInicio)) : this.montaDataInicioAlocacaoNormal(dataInicio);

            return datas;
        }

    }
    @computed
    get isCentroCustoDebitoMediaPulse() {
        return (this.targetCentroCustoDebito && this.targetCentroCustoDebito == "MEDIAPULSE");
    }

    @computed
    get isJustificativaCusteioDireto() {
        let justificativa = this.solicitacao.justificativaContratacao;
        let produtoOracle = justificativa ? justificativa.produtoOracle : null;
        return produtoOracle;
    }

    @computed
    get mensagemAlertaAlocacao() {

        let centroCustoDebito = this.solicitacao.centroCustoDebito;
        let codProduto = this.solicitacao.produto.codigo;
        let chaveContabil = centroCustoDebito + "-" + codProduto;
        let mensagem = null;

        let mensagemCusteioDireto = "Caso queira custear pelo projeto escolhido no SGTMOT, selecione uma justificativa 'Exclusiva p/ custeio direto'. "
        let mensagemCentroCusto = `O custeio mensal será realizado na chave contábil ${chaveContabil}.`

        if (this.isCentroCustoDebitoMediaPulse) {
            mensagem = isJustificativaCusteioDireto ? mensagemCentroCusto : mensagemCusteioDireto;
        } else {

        }

        return mensagem;
    }

    @computed
    get isSistemaAlocacaoDiferente() {

        let check = false;
        const centroCustoDebito = this.solicitacao.centroCustoDebito;

        if (centroCustoDebito && centroCustoDebito !== "") {
            let target = this.isCentroCustoDebitoMediaPulse && this.isJustificativaCusteioDireto ? "MOT": this.targetCentroCustoDebito;
            
            let sistemaAlocacaoVigente = this.sistemaAlocacaoVigente;

            check = (target && target !== "" &&
                sistemaAlocacaoVigente && sistemaAlocacaoVigente !== "" &&
                target !== sistemaAlocacaoVigente);
        }
        return check
    }

    @computed
    get mensagemCentroCustoDebitoMediapulse() {
        let mensagem = "Este centro de custo segue regras de planejamento/alocação de recursos. Caso queira definir o custeio pelo SGTMOT, selecione uma justificativa 'Exclusiva p/ custeio direto'."
        return this.isCentroCustoDebitoMediaPulse ? mensagem : "";
    }

    @computed
    get mensagemTrocaSistemaAlocacao() {

        const centroCustoOriginal = this.dadosOriginais.centroCustoDebito;
        const centroCustoSelecionado = this.solicitacao.centroCustoDebito;

        let mensagem = ""
        if (this.isSistemaAlocacaoDiferente) {
            if (this.isJustificativaCusteioDireto && this.isJustificativaAlterada){
                mensagem = "A migração para projeto/centro de resultado/finalidade exclusivo para custeio direto só é permitida para inicio de competência.";
            } else if (centroCustoOriginal !== centroCustoSelecionado){
                mensagem = `A migração entre ${centroCustoOriginal} e ${centroCustoSelecionado} só é permitida para inicio de competência.`
            } else{
                if (!this.isJustificativaCusteioDireto && this.isJustificativaAlterada){
                    mensagem = `A migração entre ${centroCustoOriginal} e ${centroCustoSelecionado} só é permitida para inicio de competência.`
                }
                mensagem = `A migração entre ${centroCustoOriginal} e ${centroCustoSelecionado} só é permitida para inicio de competência.`
            }
            
        } else {

            if (this.isCentroCustoDebitoMediaPulse && this.isCentroCustoDebitoAlterado) {
                mensagem = "Alteração de centro de custo débito deve ser migrada na data inicio de competência.";
            } else if (this.isCentroCustoDebitoMediaPulse && ((this.isJustificativaAlterada && !this.isJustificativaCusteioDireto) || this.isGestorDebitoAlterado)) {
                mensagem = "Alterações devem ser migradas na data inicio de competência.";
            } else if (this.isCentroCustoDebitoMediaPulse && this.sistemaAlocacaoVigente == 'MEDIAPULSE' && this.isJustificativaCusteioDireto) {
                mensagem = "A migração para projeto/centro de resultado/finalidade exclusivo para custeio direto só é permitida na data inicio de competência.";
            } 
        }
        return mensagem;
    }

/*     @computed
    get produtoOptions() {
        return this.produtos ? this.produtos : [];
    } */

    @computed
    get isGestorAreaDebitoSelecionado() {
        return this.solicitacao.gestorAreaDebito && this.solicitacao.gestorAreaDebito.matricula;
    }

    @computed
    get isProdutoEditavel() {
        let mediaPulse = (this.targetCentroCustoDebito && this.targetCentroCustoDebito == "MEDIAPULSE");
        let editavel = (this.solicitacao.justificativaContratacao &&
            _.get(this.solicitacao, "justificativaContratacao.justificativaAlocavel") !== "NAO" &&
            !(!this.solicitacao.justificativaContratacao.produtoOracle && mediaPulse));
        return editavel;
    }

    @computed
    get isDadosAlterados() {
        return (this.isJustificativaAlterada ||
            this.isCentroCustoDebitoAlterado ||
            this.isGestorDebitoAlterado ||
            this.isProdutoAlterado);

    }
    @computed
    get isJustificativaAlterada() {
        return (this.dadosOriginais.justificativaContratacaoId != this.solicitacao.justificativaContratacaoId);
    }
    @computed
    get isCentroCustoDebitoAlterado() {
        return this.solicitacao.centroCustoDebito ? (this.dadosOriginais.centroCustoDebito != this.solicitacao.centroCustoDebito) : false;
    }
    @computed
    get isGestorDebitoAlterado() {
        return this.solicitacao.gestorAreaDebito ? (this.dadosOriginais.matriculaGestorDebito != this.solicitacao.gestorAreaDebito.matricula) : false;
    }
    @computed
    get isProdutoAlterado() {
        return this.solicitacao.produtoId ? (this.dadosOriginais.produtoId != this.solicitacao.produtoId) : false;
    }

    @computed
    get isDataSelecionada() {
        return this.data != null;
    }

    @computed
    get temAlocacaoMaiorQueDataSelecionada() {
        const dataSeleciona = this.data;
        const alocacoes = this.alocacoesProdutoMot.filter(a => a.dataInicio > dataSeleciona);
        return alocacoes.length > 0;
    }
    @computed
    get mensagemAlocacaoMaiorQueData() {

        let mensagem = ""
        if (this.isSistemaAlocacaoDiferente && this.temAlocacaoMaiorQueDataSelecionada) {
            mensagem = "Existem alocações mais recentes que a data selecionada. Estas alocações serão excluídas ao confirmar a migração.";
        }
        return mensagem;
    }

    montaDataInicioAlocacaoNormal(dataInicioCompetencia) {

        let dataInicio = dataInicioCompetencia.clone();

        // recupera a data de inicio do contrato
        const dataInicioContrato = moment(this.solicitacao.momentDataInicio.format('DD-MM-YYYY'), 'DD-MM-YYYY');
        // recupera a data de termino do contrato
        const dataTerminoContrato = moment(this.solicitacao.momentDataTermino.format('DD-MM-YYYY'), 'DD-MM-YYYY');

        if (dataInicioContrato.isAfter(dataInicio)) {
            //Se a data inicio do contrato for posterior à data calculada, utiliza-a
            dataInicio = dataInicioContrato.clone();
        }

        //let dataTermino = dataInicio.clone().subtract(1, 'day').add(1, 'month');
        //  if (dataTermino.isAfter(dataTerminoContrato)) {
        //Se a data termino do contrato for anterior à data de termino calculada, utiliza-a
        let dataTermino = dataTerminoContrato.clone();
        //  }


        return {
            dataInicioVigencia: dataInicio,
            dataFim: dataTermino,
            datasRestritas: [] //this.alocacoesProdutoMot.map(al => moment(al.dataInicio))
        };

    }

    montaDataInicioAlocacaoDiferente(dataInicioCompetencia) {

        let dataInicio, dataTermino;
        let datasRestritas = [];

        dataInicio = dataInicioCompetencia.clone();

        const diaInicioCompetencia = dataInicioCompetencia.date();

        // Recupera a data de termino do contrato
        const dataTerminoContrato = moment(this.solicitacao.momentDataTermino.format('DD-MM-YYYY'), 'DD-MM-YYYY');
        const diaTerminoContrato = dataTerminoContrato.date();

        let mesTermino = dataTerminoContrato.month();
        let anoTermino = dataTerminoContrato.year();

        const ultimaCompetencia = moment({ day: diaInicioCompetencia, month: mesTermino, year: anoTermino });

        dataTermino = (diaTerminoContrato < diaInicioCompetencia) ?
            ultimaCompetencia.clone().subtract(1, 'months') :
            ultimaCompetencia.clone();

        let dataAtual = dataInicio.clone().add(1, 'days');

        let dia = null;
        while (dataAtual.isBefore(dataTermino)) {

            dia = dataAtual.clone().date();

            if (dia != diaInicioCompetencia)
                datasRestritas.push(moment(dataAtual.format('DD/MM/YYYY'), 'DD/MM/YYYY'));

            dataAtual.add(1, 'days');
        }

        let datas = {
            dataInicioVigencia: dataInicio,
            dataFim: dataTermino,
            datasRestritas: datasRestritas
        }
        return datas;

    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: undefined,
            codigo: "",
            nome: "",
            justificativaContratacaoId: "",
            justificativaContratacao: {
                id: 0,
                nome: ""
            },
            descricaoMot: "",
            sistemaAlocacao: null,
            ativo: true
        };
    }

    resetProduto() {
        this.solicitacao.produtoId = "";
        //this.solicitacao.produto = null;
        this.produtoSelecionado = undefined;
    }
    setProduto(value, options) {
        if (value == "" || value == null) {
            this.resetProduto();
        }
        else {
            this.solicitacao.produtoId = value;
            this.solicitacao.produto = options[0];
            this.produtoSelecionado = this.solicitacao.produto;
        }
    }

    carregarDados(idSolicitacaoEtt) {
        this.loading = true;
        this.solicitacaoService.carregarDadosMigracao(idSolicitacaoEtt).then(response => {
            this.dados = response.data;
            this.loading = false;

            //this.getAlocacoesProdutoMot(idSolicitacaoEtt);
            //            this.getAtributosAlocacao();
            //            this.montaPeriodoMigracao(this.parametrosGeraisStore.parametros.pgmDiaGerControlePonto);

        }).catch(error => {
            console.log(error.response.data.message);
            this.loading = false;
        });
    }

    filtrarAreaDebito(input, callback) {
        const result = [];
        if (input && input.length === 11) {
            if (this.gestoresArDebito.length === 0) {
                // transformar o valor digitado em caixa alta para resolver erro em lotes de pagto 
                input = input.toUpperCase();
                this.areaService.getGestorByCodigoArDebitoEEmpresaGloboId(input, this.solicitacao.localContratacaoId).then(response => {
                    if (!!response.data) {
                        this.gestoresArDebito = response.data.gestores;
                        this.targetCentroCustoDebito = response.data.target;
                        result.push({ value: input, label: input });
                    }
                    callback(null, {
                        options: result,
                        complete: false
                    });
                }).catch(error => {
                    callback(null, {
                        options: result,
                        complete: false
                    });
                    console.log(error);
                });
            }
        } else {
            callback(null, {
                options: result,
                complete: false
            });
        }
    }

    // SETS    
    setCentroCustoDebito(value) {
        this.solicitacao.centroCustoDebito = value;
        if (!value || value == null || value === '') {
            this.carregarGestoresArDebito();
        } else if (value.length === 11) {
            //            this.getAtributosAlocacao();
            this.centroCustoDebitoSelecionado = this.solicitacao.centroCustoDebito;
        }
    }

    setGestorAreaDebito(value, options) {
        this.solicitacao.gestorAreaDebito = null;
        if (options && options.length > 0) {
            this.solicitacao.gestorAreaDebito = options[0];
            this.isLoadingGestorArDebito = false;
        }
    }

    setJustificativaContratacao(value) {
        this.solicitacao.justificativaContratacaoId = value;
        this.solicitacao.justificativaContratacao = getByAtribute(this.justificativasContratacao, value, "id");

        this.justificativaAlterada = true;
        this.produtoSelecionado = undefined;

        const justificativa = this.solicitacao.justificativaContratacao;

        this.solicitacao.produtoId = "";

        this.resetJustificativa();
        this.resetProduto();
    }


    setDetalhamentoJustificativa(value) {
        this.solicitacao.detalhamentoJustificativa = value;
    }

    setData = (value) => {
        let date = value;
        if (date) {
            date = moment(date.format('DD/MM/YYYY'), "DD/MM/YYYY");

            this.momentData = date;
            this.data = date.toJSON();
            this.dataValidacao = date.format("DD/MM/YYYY")
        } else {
            this.momentData = null;
            this.data = null;
            this.dataValidacao = null;
        }
    };
    setDataAlocacaoCheck(value) {
        this.dataValidacao = value;
        if (!value) {
            //            this.solicitacaoProrrogacao.dataFinalProrrogada = "";
            this.this.dataValidacao = null;
            this.data = null;
            this.momentData = null;
        }
    }

    setObservacoesMigracao(value) {
        this.observacoesMigracao = value;
    }

    carregarGestoresArDebito = () => {
        this.gestoresArDebito = [];
        this.targetCentroCustoDebito = "MOT";
        if (this.solicitacao.centroCustoDebito && this.solicitacao.localContratacaoId) {
            this.isLoadingArDebito = true;
            this.areaService.getGestorByCodigoArDebitoEEmpresaGloboId(this.solicitacao.centroCustoDebito, this.solicitacao.localContratacaoId).then(response => {
                if (!!response.data) {
                    this.gestoresArDebito = response.data.gestores;
                    this.targetCentroCustoDebito = response.data.target;
                    const idAprovador = _.get(this.solicitacao, "gestorAreaDebito.idAprovador");
                    if (idAprovador) {
                        if (!getByAtribute(this.gestoresArDebito, idAprovador, "idAprovador")) {
                            this.solicitacao.gestorAreaDebito = null;
                        }
                    }
                } else {
                    this.gestoresArDebito = [];
                    this.solicitacao.centroCustoDebito = null;
                    this.solicitacao.gestorAreaDebito = null;
                }
                this.isLoadingArDebito = false;
            }).catch(error => {
                console.log(error)
                this.isLoadingArDebito = false;
                this.gestoresArDebito = [];
                this.solicitacao.gestorAreaDebito = null;
                this.solicitacao.centroCustoDebito = null;
            })
        } else {
            this.gestoresArDebito = [];
            this.solicitacao.gestorAreaDebito = null;
            this.solicitacao.centroCustoDebito = null;
        }
    }

    montaPeriodoMigracao(pgmDiaGerControlePonto) {
        const dataAtual = moment();
        const diaDoMes = dataAtual.date();

        let dataInicio, dataFim;
        if (diaDoMes > pgmDiaGerControlePonto) {
            const diferenca = diaDoMes - pgmDiaGerControlePonto;
            dataInicio = dataAtual.subtract(diferenca, 'days');
            dataFim = dataInicio.add(30, 'days');
        } else {
            dataInicio = dataAtual;
        }
    }

    //override (FluxoStore)
    carregarProdutosPelaJustificativaInicial(setProdutosCallback) {

    }
    //override
    carregarDadosExtras = (response, carregandoDadosPor, dadosUrl) => {
        this.justificativaInicial = JSON.parse(JSON.stringify(this.solicitacao.justificativaContratacao));
        this.carregarGestoresArDebito();

        this.dadosOriginais.centroCustoDebito = this.solicitacao.centroCustoDebito;
        this.dadosOriginais.matriculaGestorDebito = this.solicitacao.gestorAreaDebito.matricula;
        this.dadosOriginais.justificativaContratacaoId = this.solicitacao.justificativaContratacaoId;
        this.dadosOriginais.produtoId = this.solicitacao.produtoId;
        
        if (this.solicitacao.produto !== undefined){
            this.solicitacao.produto.label = this.solicitacao.produto.nome + " (" + this.solicitacao.produto.codigo + ")";
        }
        this.produtoSelecionado = this.solicitacao.produto;

    };

    migrar = () => {
        return this.solicitacaoService.migrar({
            idSolicitacaoEtt: this.solicitacaoEtt.idSolicitacaoEtt,
            justificativaContratacaoId: this.solicitacao.justificativaContratacaoId,
            centroCustoDebito: this.solicitacao.centroCustoDebito,
            gestorAreaDebito: this.solicitacao.gestorAreaDebito,
            idNovoProduto: this.solicitacao.produtoId,
            dataInicio: this.data,
            observacoes: this.solicitacao.detalhamentoJustificativa
        })

    }

    getTarefasFluxo(){
        if (this.idFluxo !== undefined){
            this.fluxoService.getEvolucaoFluxo(this.idFluxo).then(response => {
                //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
                if(response && response.data && Array.isArray(response.data)) {
                    this.evolucaoFluxo = response.data;
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }
    
}